import React, { useState } from 'react';
import { Button } from '@components/ui/button';
import { Card } from '@components/ui/card';

const MOTIVATION_OPTIONS = [
  {
    id: 'academic',
    title: 'Academic success (homework, exams, grades)',
    description: '',
  },
  {
    id: 'test-prep',
    title: 'Test preparation (SAT, ACT, AP, IB, JEE, etc.)',
    description: '',
  },
  {
    id: 'college-prep',
    title: 'College preparation & admissions',
    description: '',
  },
  {
    id: 'difficult-concepts',
    title: 'Understanding difficult concepts',
    description: '',
  },
  {
    id: 'curiosity',
    title: 'Personal curiosity & growth',
    description: '',
  },
  {
    id: 'career',
    title: 'Career preparation & skill development',
    description: '',
  },
  {
    id: 'other',
    title: 'Other (please specify)',
    description: '',
  },
];

const MotivationStep = ({ onNext, onBack, formData, canGoBack }) => {
  const [selectedMotivation, setSelectedMotivation] = useState(formData.motivation || '');

  const handleContinue = () => {
    onNext({ motivation: selectedMotivation });
  };

  return (
    <div className="space-y-8 animate-fade-in">
      <div className="text-center space-y-4">
        <h1 className="text-3xl font-bold text-foreground">Why are you learning this?</h1>
        <p className="text-muted-foreground max-w-2xl mx-auto">
          Understanding your 'why' helps us personalize your journey and keep you motivated.
        </p>
      </div>

      <div className="space-y-4">
        <p className="text-sm font-medium text-foreground">Select your motivation</p>

        <div className="space-y-3">
          {MOTIVATION_OPTIONS.map((option) => (
            <Card
              key={option.id}
              className={`p-4 cursor-pointer transition-all hover:bg-secondary/80 ${
                selectedMotivation === option.id ? 'bg-primary/10 border-primary' : 'bg-secondary border-border'
              }`}
              onClick={() => setSelectedMotivation(option.id)}>
              <div className="flex items-center space-x-3">
                <div
                  className={`w-4 h-4 rounded-full border-2 ${
                    selectedMotivation === option.id ? 'bg-primary border-primary' : 'border-border'
                  }`}>
                  {selectedMotivation === option.id && <div className="w-full h-full rounded-full bg-primary" />}
                </div>
                <p className="font-medium text-foreground">{option.title}</p>
              </div>
            </Card>
          ))}
        </div>
      </div>

      <div className="flex justify-between pt-8">
        {canGoBack && (
          <Button variant="outline" onClick={onBack} className="px-8">
            Back
          </Button>
        )}
        <Button onClick={handleContinue} disabled={!selectedMotivation} className="px-8 ml-auto">
          Continue
        </Button>
      </div>
    </div>
  );
};

export default MotivationStep;
